// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  height: 100%;
  overflow-x: hidden;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
    sans-serif;
  line-height: 1.6;
  background: rgb(10, 10, 15); /* Add this to prevent white flash */
  margin-right: 0; /* Ensure no margin interferes */
  padding-right: 0; /* Ensure scrollbar has space */
}

#root {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: rgb(10, 10, 15); /* Match your app's dark theme */
}

/* Custom Scrollbar */
::-webkit-scrollbar {
  width: 10px;
  z-index: 9999; /* Higher than navbar z-index */
}

::-webkit-scrollbar-track {
  background: rgb(10, 10, 15);
}

::-webkit-scrollbar-thumb {
  background: rgb(59, 130, 246);
  border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgb(37, 99, 235);
}

/* Selection */
::selection {
  background: rgba(59, 130, 246, 0.3);
  color: white;
}

/* Smooth transitions */
button,
a,
input,
textarea {
  transition: all 0.2s ease;
}

/* Focus styles */
button:focus-visible,
a:focus-visible,
input:focus-visible,
textarea:focus-visible {
  outline: 2px solid rgb(59, 130, 246);
  outline-offset: 2px;
}

/* Line clamp utility */
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.line-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE;cACY;EACZ,gBAAgB;EAChB,2BAA2B,EAAE,oCAAoC;EACjE,eAAe,EAAE,gCAAgC;EACjD,gBAAgB,EAAE,+BAA+B;AACnD;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,2BAA2B,EAAE,gCAAgC;AAC/D;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,aAAa,EAAE,+BAA+B;AAChD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,cAAc;AACd;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA,uBAAuB;AACvB;;;;EAIE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;;;;EAIE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml,\nbody {\n  height: 100%;\n  overflow-x: hidden;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\",\n    sans-serif;\n  line-height: 1.6;\n  background: rgb(10, 10, 15); /* Add this to prevent white flash */\n  margin-right: 0; /* Ensure no margin interferes */\n  padding-right: 0; /* Ensure scrollbar has space */\n}\n\n#root {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: rgb(10, 10, 15); /* Match your app's dark theme */\n}\n\n/* Custom Scrollbar */\n::-webkit-scrollbar {\n  width: 10px;\n  z-index: 9999; /* Higher than navbar z-index */\n}\n\n::-webkit-scrollbar-track {\n  background: rgb(10, 10, 15);\n}\n\n::-webkit-scrollbar-thumb {\n  background: rgb(59, 130, 246);\n  border-radius: 5px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: rgb(37, 99, 235);\n}\n\n/* Selection */\n::selection {\n  background: rgba(59, 130, 246, 0.3);\n  color: white;\n}\n\n/* Smooth transitions */\nbutton,\na,\ninput,\ntextarea {\n  transition: all 0.2s ease;\n}\n\n/* Focus styles */\nbutton:focus-visible,\na:focus-visible,\ninput:focus-visible,\ntextarea:focus-visible {\n  outline: 2px solid rgb(59, 130, 246);\n  outline-offset: 2px;\n}\n\n/* Line clamp utility */\n.line-clamp-2 {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.line-clamp-3 {\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
